import React from 'react';
import { CreditCard, ArrowRight, Check, DollarSign } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const StripePage = () => {
  const { login } = useAuth();
  const features = ['Pagamentos no chat', 'Links de pagamento', 'Assinaturas recorrentes', 'Reembolsos automáticos'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <CreditCard className="h-4 w-4" />Integração Stripe
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Integração com <span className="text-purple-600">Stripe</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">Aceite pagamentos diretamente no chat com a integração oficial do Stripe.</p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">Começar gratuitamente</Button>
            </div>
            <div className="bg-purple-50 rounded-3xl p-8">
              <div className="bg-white rounded-2xl p-6 shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-purple-600 rounded-xl flex items-center justify-center"><DollarSign className="h-6 w-6 text-white" /></div>
                  <div><p className="font-semibold">Pagamento</p><p className="text-sm text-gray-500">Via Stripe</p></div>
                </div>
                <p className="text-2xl font-bold mb-4">R$ 199,00</p>
                <Button className="w-full bg-purple-600 hover:bg-purple-700">Pagar agora</Button>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos da Integração</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (<div key={f} className="bg-white rounded-xl p-6 shadow-sm"><Check className="h-6 w-6 text-green-500 mb-3" /><p className="font-medium text-gray-900">{f}</p></div>))}
            </div>
          </div>
        </div>
        <div className="py-16"><div className="max-w-4xl mx-auto px-4"><Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white"><CardContent className="py-12 text-center"><h2 className="text-2xl font-bold mb-4">Comece a receber pagamentos</h2><Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">Começar agora <ArrowRight className="ml-2 h-4 w-4" /></Button></CardContent></Card></div></div>
      </main>
      <Footer />
    </div>
  );
};
export default StripePage;
